import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/peerReviewedPublication/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/peerReviewedPublication/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/peerReviewedPublication', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/peerReviewedPublication', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/peerReviewedPublication/' + id)
  }
}
